const updates = [
  { date: '08-01', title: '《消失的她》高清修复版上线，悬疑迷必看神作', tag: '新片上线', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-31', title: '暑期综艺特辑更新：《奔跑吧》最新一期已同步', tag: '综艺更新', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-30', title: '平台新增4K超清专区，百部经典影片画质升级', tag: '功能升级', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '07-29', title: '《狂飙》全集高清版资源整理完毕，一次看过瘾', tag: '资源更新', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-28', title: '国产科幻《流浪地球3》预告片专区已上线', tag: '新片预告', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-27', title: '经典动漫《灌篮高手》重制版全集上线成全影院', tag: '经典重温', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '07-26', title: '网站服务器全面升级，观影流畅度再提升30%', tag: '系统优化', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '07-25', title: '悬疑剧场新增50部高分推理电影，周末刷起来', tag: '专题更新', tagColor: 'bg-primary-100 text-primary-700' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-50 rounded-full mb-3 whitespace-nowrap">
              最新动态
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              最新更新
            </h2>
            <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
              第一时间了解成全影院的最新资源与功能动态
            </p>
          </div>

          <div className="max-w-[900px] mx-auto">
            <div className="relative pl-8 md:pl-10 border-l-2 border-background-200">
              {updates.map((item, i) => (
                <div key={i} className={`relative pb-8 ${i === updates.length - 1 ? 'pb-0' : ''}`}>
                  <div className="absolute -left-[25px] md:-left-[29px] top-0 w-4 h-4 rounded-full bg-background-50 border-2 border-primary-400"></div>
                  <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                    <span className="text-xs font-medium text-foreground-400 whitespace-nowrap font-mono">{item.date}</span>
                    <span className={`px-2 py-0.5 text-xs font-medium rounded-md whitespace-nowrap self-start ${item.tagColor}`}>{item.tag}</span>
                  </div>
                  <p className="mt-2 text-sm md:text-base text-foreground-700 leading-relaxed">{item.title}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}